// dayjs-setup.ts
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/el';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import minMax from 'dayjs/plugin/minMax';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(duration);
dayjs.extend(minMax);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('en-gb');

// IMPORTANT: utc first, then timezone
dayjs.extend(utc);
dayjs.extend(timezone);

// Optional: set your default tz so AntD/you get consistent “now”
// TODO : Check this also might not be correct
dayjs.tz.setDefault('Europe/Athens');

export default dayjs;
